import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guard/auth-guard.guard';

import { environment } from 'src/environments/environment';
// import { CanActivateFn } from '@angular/router';

const registerRoute: Routes = environment.baseUrls.isProd
  ? []
  : [
      {
        path: 'register',
        loadComponent: () =>
          import('./pages/register/register.component').then(
            (m) => m.RegisterComponent,
          ),
        data: { title: 'Register - Astragate' },
      },
    ];

const routes: Routes = [
  // {
  //   path: '',
  //   loadComponent: () =>
  //     import('./pages/landing/landing.component').then(
  //       (m) => m.LandingComponent,
  //     ),
  //   data: { title: 'Astragate Developer Portal' },
  // },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
    data: { title: 'Login - Astragate' },
  },
  ...registerRoute,
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./layouts/dashboard-layout/dashboard-layout.component').then(
        (m) => m.DashboardLayoutComponent,
      ),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full',
      },

      {
        path: 'main',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
        data: { title: 'Dashboard - Astragate' },
      },

      {
        path: 'collections',
        loadComponent: () =>
          import('./pages/deposits/deposits.component').then(
            (m) => m.DepositsComponent,
          ),
        data: { title: 'Collections - Astragate' },
      },

      {
        path: 'transactions',
        loadComponent: () =>
          import('./pages/transactions/transactions.component').then(
            (m) => m.TransactionsComponent,
          ),
        data: { title: 'transactions - Astragate' },
      },

      {
        path: 'settlement-history',
        loadComponent: () =>
          import('./pages/settlements/settlement-history/settlement-history.component').then(
            (m) => m.SettlementHistoryComponent,
          ),
        data: { title: 'settlement transactions - Astragate' },
      },

      {
        path: 'settlement-details/:id',
        loadComponent: () =>
          import('./pages/settlements/settlement-details/settlement-details.component').then(
            (m) => m.SettlementDetailsComponent,
          ),
        data: { title: 'settlement details - Astragate' },
      },

      {
        path: 'initiate-settlement',
        loadComponent: () =>
          import('./pages/settlements/initiate-settlement/initiate-settlement.component').then(
            (m) => m.InitiateSettlementComponent,
          ),
        data: { title: 'initiate settlement - Astragate' },
      },

      {
        path: 'bulk-transactions',
        loadComponent: () =>
          import('./pages/bulk-transactions/bulk-transactions.component').then(
            (m) => m.BulkTransactionsComponent,
          ),
        data: { title: 'bulk transactions - Astragate' },
      },

      {
        path: 'transactions/:id',
        loadComponent: () =>
          import('./pages/transaction-details/transaction-details.component').then(
            (m) => m.TransactionDetailsComponent,
          ),
        data: { title: 'transactions details - Astragate' },
      },

      {
        path: 'payouts',
        loadComponent: () =>
          import('./pages/payouts/payouts.component').then(
            (m) => m.PayoutsComponent,
          ),
        data: { title: 'Payouts - Astragate' },
      },

      {
        path: 'initiate-payouts',
        loadComponent: () =>
          import('./pages/initiate-payouts/initiate-payouts.component').then(
            (m) => m.InitiatePayoutsComponent,
          ),
        data: { title: 'Initiate Payouts - Astragate' },
      },

      {
        path: 'initiate-collections',
        loadComponent: () =>
          import('./pages/initiate-deposits/initiate-deposits.component').then(
            (m) => m.InitiateDepositsComponent,
          ),
        data: { title: 'Initiate Collections - Astragate' },
      },

      {
        path: 'payouts/:id',
        loadComponent: () =>
          import('./pages/payout-details/payout-details.component').then(
            (m) => m.PayoutDetailsComponent,
          ),
      },

      {
        path: 'collections/:id',
        loadComponent: () =>
          import('./pages/deposit-details/deposit-details.component').then(
            (m) => m.DepositDetailsComponent,
          ),
      },

      {
        path: 'configurations',
        loadComponent: () =>
          import('./pages/configurations/configurations.component').then(
            (m) => m.ConfigurationsComponent,
          ),
        data: { title: 'Configurations - Astragate' },
      },

      {
        path: 'checkout-config',
        loadComponent: () =>
          import('./pages/checkout-config/checkout-config.component').then(
            (m) => m.CheckoutConfigComponent,
          ),
        data: { title: 'Checkout Configurations - Astragate' },
      },

      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/profile-config/profile-config.component').then(
            (m) => m.ProfileConfigComponent,
          ),
        data: { title: 'Checkout Configurations - Astragate' },
      },

      {
        path: 'payment-links',
        loadComponent: () =>
          import('./pages/payment-links/payment-links.component').then(
            (m) => m.PaymentLinksComponent,
          ),
        data: { title: 'Payment links - Astragate' },
      },

      {
        path: 'float-deposits',
        loadComponent: () =>
          import('./pages/float-deposits/float-deposits.component').then(
            (m) => m.FloatDepositsComponent,
          ),
        data: { title: 'Float Deposits - Astragate' },
      },


      {
        path: 'payment-links/create',
        loadComponent: () =>
          import('./pages/create-payment-link/create-payment-link.component').then(
            (m) => m.CreatePaymentLinkComponent,
          ),
        data: { title: 'Create Payment links - Astragate' },
      },

      {
        path: 'payment-links/:id',
        loadComponent: () =>
          import('./pages/payment-link-details/payment-link-details.component').then(
            (m) => m.PaymentLinkDetailsComponent,
          ),
        data: { title: 'Payment links - Astragate' },
      },

      {
        path: 'sms',
        loadComponent: () =>
          import('./pages/sms/sms.component').then((m) => m.SmsComponent),
        data: { title: 'sms - Astragate' },
      },

      {
        path: 'contact-us',
        loadComponent: () =>
          import('./pages/contact-us/contact-us.component').then((m) => m.ContactUsComponent),
        data: { title: 'contact us - Astragate' },
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
    data: { title: 'Not found - Astragate' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
